import React, { useEffect, useState } from 'react';
import { TextField, Container, ThemeProvider, createTheme, Box, AppBar, Toolbar, Grid, Typography, Autocomplete } from '@mui/material';
import ProjectList from './ProjectList';
import MyTitle from './MyTitle';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { tagOptionsIndustoryList, tagOptionsSkillList, tagOptionsConsulLayerList } from './tagOptions';
import Footer from './Footer';
import { officeOrHomeList } from './officeOrHome';

const theme = createTheme({
  palette: {
    background: {
      default: '#EFF6FF', // Background color
    },
  },
});

const headerStyle = {
  top: 0,
  width: "100%",
  backgroundColor: "white",
  zIndex: 1000,
};

function App() {
  const [searchQueryFreeword, setSearchQueryFreeword] = useState('');
  const [searchQueryWorkstyle, setSearchQueryWorkstyle] = useState('');
  const [selectedTagOptions, setSelectedTagOptions] = useState({ 'industory': [], 'skill': [], 'consul_layer': [] });
  const [tagOptionsList, setTagOptionsList] = useState({ 'industory': tagOptionsIndustoryList, 'skill': tagOptionsSkillList, 'consul_layer': tagOptionsConsulLayerList });
  const [searchQueryReward, setSearchQueryReward] = useState({ lower_reward: '', upper_reward: '' });
  const [searchQueryUtilizationRate, setSearchQueryUtilizationRate] = useState({ lower_utilization_rate: '', upper_utilization_rate: '' });
  const [selectedOfficeOrHome, setSelectedOfficeOrHome] = useState('');

  const handleSearchChangeFreeword = (event) => {
    setSearchQueryFreeword(event.target.value);
  };
  const handleSearchChangeWorkstyle = (event) => {
    setSearchQueryWorkstyle(event.target.value);
  };
  const handleTagOptionChange = (key, value) => {
    setSelectedTagOptions({...selectedTagOptions, [key]: value});
    if (value.length === 0) {
      if (key === 'industory') setTagOptionsList({...tagOptionsList, [key]: tagOptionsIndustoryList})
      if (key === 'skill') setTagOptionsList({...tagOptionsList, [key]: tagOptionsSkillList})
      if (key === 'consul_layer') setTagOptionsList({...tagOptionsList, [key]: tagOptionsConsulLayerList})
    } else {
      setTagOptionsList({...tagOptionsList, [key]: tagOptionsList[key].filter(option => !value.includes(option))})
    }
  }
  const handleSearchChangeReward = (e) => {
    setSearchQueryReward({...searchQueryReward, [e.target.name]: e.target.value});
  };
  const handleSearchChangeUtilizationRate = (e) => {
    setSearchQueryUtilizationRate({...searchQueryUtilizationRate, [e.target.name]: e.target.value});
  };
  const handleOfficeOrHomeChange = (event, newSelectedOfficeOrHome) => {
    setSelectedOfficeOrHome(newSelectedOfficeOrHome);
  }

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ backgroundColor: theme.palette.background.default, minHeight: '100vh' }}>
        <header class="header" style={headerStyle}>
          <nav className="navbar">
            <a href="/">
              <img
                  className="logo logo-mw"
                  src={"https://consultingstudio.jp/img/pf_logo_top.png"}
                  style={{ margin: "5px", objectFit: "cover" }}
              />
            </a>
          </nav>
        </header>

        <Container style={{ width: '100%', paddingTop: '40px', paddingBottom: '40px' }}>
          <MyTitle />
          <Grid container spacing={3}>
            <Grid item xs={12} md={3}>
              <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>検索条件</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <TextField
                      label="フリーワード"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      value={searchQueryFreeword}
                      onChange={handleSearchChangeFreeword}
                    />
                    <TextField
                      label="勤務形態"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      value={searchQueryWorkstyle}
                      onChange={handleSearchChangeWorkstyle}
                    />
                    <Autocomplete
                      multiple
                      options={tagOptionsList.industory}
                      value={selectedTagOptions.industory}
                      onChange={(e, value) => handleTagOptionChange('industory', value)}
                      renderInput={(params) => <TextField {...params} label="業界" />}
                      placeholder="業界"
                      sx={{ mt: 2, mb: 1 }}
                    />
                    <Autocomplete
                      multiple
                      options={tagOptionsList.skill}
                      value={selectedTagOptions.skill}
                      onChange={(e, value) => handleTagOptionChange('skill', value)}
                      renderInput={(params) => <TextField {...params} label="スキル" />}
                      placeholder="スキル"
                      sx={{ mt: 2, mb: 1 }}
                    />
                    <Autocomplete
                      multiple
                      options={tagOptionsList.consul_layer}
                      value={selectedTagOptions.consul_layer}
                      onChange={(e, value) => handleTagOptionChange('consul_layer', value)}
                      renderInput={(params) => <TextField {...params} label="レイヤー" />}
                      placeholder="レイヤー"
                      sx={{ mt: 2, mb: 1 }}
                    />
                    <Typography sx={{ mt: 2, mb: 0 }} gutterBottom>報酬</Typography>
                    <Box sx={{ mt: 0, mb: 1 }} display="flex" alignItems="center">
                      <TextField
                        label="下限"
                        name="lower_reward"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={searchQueryReward.lower_reward}
                        onChange={handleSearchChangeReward}
                        sx={{ width: 100, mr: 0.5, mt: 0.5 }}
                      />
                      <Typography sx={{ mx: 0.5 }}>〜</Typography>
                      <TextField
                        label="上限"
                        name="upper_reward"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={searchQueryReward.upper_reward}
                        onChange={handleSearchChangeReward}
                        sx={{ width: 100, mx: 0.5, mt: 0.5 }}
                      />
                      <Typography sx={{ mx: 0.5 }}>万円/人月</Typography>
                    </Box>
                    <Typography sx={{ mt: 2, mb: 0 }} gutterBottom>稼働率</Typography>
                    <Box sx={{ mt: 0, mb: 1 }} display="flex" alignItems="center">
                      <TextField
                        label="下限"
                        name="lower_utilization_rate"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={searchQueryUtilizationRate.lower_utilization_rate}
                        onChange={handleSearchChangeUtilizationRate}
                        sx={{ width: 100, mr: 0.5, mt: 0.5 }}
                      />
                      <Typography sx={{ mx: 0.5 }}>〜</Typography>
                      <TextField
                        label="上限"
                        name="upper_utilization_rate"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={searchQueryUtilizationRate.upper_utilization_rate}
                        onChange={handleSearchChangeUtilizationRate}
                        sx={{ width: 100, mx: 0.5, mt: 0.5 }}
                      />
                      <Typography sx={{ mx: 0.5 }}>%</Typography>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Box>
              <Box sx={{ display: { xs: 'none', md: 'block' }, backgroundColor: 'white', p: 2 }}>
                <Typography>検索条件</Typography>
                <TextField
                  label="フリーワード"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  value={searchQueryFreeword}
                  onChange={handleSearchChangeFreeword}
                />
                <TextField
                  label="勤務形態"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  value={searchQueryWorkstyle}
                  onChange={handleSearchChangeWorkstyle}
                />
                <Autocomplete
                  multiple
                  options={tagOptionsList.industory}
                  value={selectedTagOptions.industory}
                  onChange={(e, value) => handleTagOptionChange('industory', value)}
                  renderInput={(params) => <TextField {...params} label="業界" />}
                  placeholder="業界"
                  sx={{ mt: 2, mb: 1 }}
                />
                <Autocomplete
                  multiple
                  options={tagOptionsList.skill}
                  value={selectedTagOptions.skill}
                  onChange={(e, value) => handleTagOptionChange('skill', value)}
                  renderInput={(params) => <TextField {...params} label="スキル" />}
                  placeholder="スキル"
                  sx={{ mt: 2, mb: 1 }}
                />
                <Autocomplete
                  multiple
                  options={tagOptionsList.consul_layer}
                  value={selectedTagOptions.consul_layer}
                  onChange={(e, value) => handleTagOptionChange('consul_layer', value)}
                  renderInput={(params) => <TextField {...params} label="レイヤー" />}
                  placeholder="レイヤー"
                  sx={{ mt: 2, mb: 1 }}
                />
                <Typography sx={{ mt: 2, mb: 0 }} gutterBottom>報酬</Typography>
                <Box sx={{ mt: 0, mb: 1 }} display="flex" alignItems="center">
                  <TextField
                    label="下限"
                    name="lower_reward"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={searchQueryReward.lower_reward}
                    onChange={handleSearchChangeReward}
                    sx={{ width: 100, mr: 0.5, mt: 0.5 }}
                  />
                  <Typography sx={{ mx: 0.5 }}>〜</Typography>
                  <TextField
                    label="上限"
                    name="upper_reward"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={searchQueryReward.upper_reward}
                    onChange={handleSearchChangeReward}
                    sx={{ width: 100, mx: 0.5, mt: 0.5 }}
                  />
                  <Typography sx={{ mx: 0.5 }}>万円/人月</Typography>
                </Box>
                <Typography sx={{ mt: 2, mb: 0 }} gutterBottom>稼働率</Typography>
                <Box sx={{ mt: 0, mb: 1 }} display="flex" alignItems="center">
                  <TextField
                    label="下限"
                    name="lower_utilization_rate"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={searchQueryUtilizationRate.lower_utilization_rate}
                    onChange={handleSearchChangeUtilizationRate}
                    sx={{ width: 100, mr: 0.5, mt: 0.5 }}
                  />
                  <Typography sx={{ mx: 0.5 }}>〜</Typography>
                  <TextField
                    label="上限"
                    name="upper_utilization_rate"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={searchQueryUtilizationRate.upper_utilization_rate}
                    onChange={handleSearchChangeUtilizationRate}
                    sx={{ width: 100, mx: 0.5, mt: 0.5 }}
                  />
                  <Typography sx={{ mx: 0.5 }}>%</Typography>
                </Box>
                <Autocomplete
                  options={officeOrHomeList}
                  value={selectedOfficeOrHome}
                  onChange={handleOfficeOrHomeChange}
                  renderInput={(params) => <TextField {...params} label="出社頻度" />}
                  placeholder="出社頻度"
                  sx={{ mt: 2, mb: 1 }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={9}>
              <Box sx={{ backgroundColor: 'white', p: 0 }}>
                <ProjectList 
                  searchQueryFreeword={searchQueryFreeword} 
                  searchQueryWorkstyle={searchQueryWorkstyle}
                  searchQueryTagOptions={selectedTagOptions}
                  searchQueryReward={searchQueryReward}
                  searchQueryUtilizationRate={searchQueryUtilizationRate}
                  searchQueryOfficeOrHome={selectedOfficeOrHome}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>

        <Footer />
      </Box>
    </ThemeProvider>
  );
}

export default App;

